/*
 * @Author: wangyunlin wangyunlin@morewis.com
 * @Date: 2022-10-17 22:25:57
 * @LastEditors: wangyunlin wangyunlin@morewis.com
 * @LastEditTime: 2023-04-06 22:48:20
 * @FilePath: \douyin\src\router.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);




const routes = [
    {
        path: '/',
        component: () => import('@/view/index.vue'),
        meta: {title: '快币充值'}
    }, 
    {
      path: '/error',
      component: () => import('@/view/error.vue'),
      meta: {title: '快币充值'}
    }, 
    {
        path: '/customerService',
        component: () => import('@/view/customerService.vue'),
        meta: {title: '抖币充值'}
    }, 
    {
        path: '/orderList',
        component: () => import('@/view/orderList.vue'),
        meta: {title: '钻石充值'}
    }, 
    {
        path: '/compDetails',
        component: () => import('@/view/complaint/compDetails.vue'),
        meta: {title: '钻石充值'}
    },
    {
        path: '/compChoose',
        component: () => import('@/view/complaint/compChoose.vue'),
        meta: {title: '钻石充值'}
    },
]
const router = new Router({
    routes,
});





export default router;